import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo/logo_header.png";

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-cream to-gray-50">
      <div className="bg-maroon text-white py-5 shadow-md">
        <div className="max-w-5xl mx-auto px-5 md:px-10 flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-3 group min-w-0">
            <img
              src={logo}
              alt="Shivkumar Jewellers"
              className="h-10 w-10 sm:h-12 sm:w-12 object-contain flex-shrink-0"
            />
            <span className="font-serif font-bold text-gold group-hover:text-gold-light transition-colors text-sm md:text-base truncate">
              Shivkumar Jewellers
            </span>
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-xs md:text-sm border border-gold/40 text-gold hover:bg-gold hover:text-maroon px-4 py-2 rounded-full transition-colors flex-shrink-0"
          >
             Back to Home
          </Link>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-5 md:px-10 py-10 md:py-16">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.35em] text-gold-dark font-semibold mb-3">
            <span className="h-px w-8 bg-gold" />
            Legal
            <span className="h-px w-8 bg-gold" />
          </span>
          <h1 className="font-serif text-3xl md:text-5xl text-maroon font-bold">
            Privacy Policy
          </h1>
          <p className="mt-3 text-sm text-gray-600">
            Last updated: April 2026
          </p>
        </div>

        <article className="bg-white rounded-2xl shadow-lg border border-gold/20 p-6 md:p-10 space-y-6 text-gray-700 leading-relaxed text-[15px]">
          <p>
            This Privacy Policy sets out the basis on which information
            collected from the users or provided by the users is processed by
            us, <strong className="text-maroon">SHIVKUMAR JEWELLERS</strong>,
            a company incorporated under the laws of India and having its
            registered office at Ahmedabad, IN and/or its subsidiary(ies)
            and/or affiliate(s) (collectively hereinafter referred to as the
            "SHIVKUMAR JEWELLERS"), which operates various websites, apps,
            newsletters and other services including but not limited to
            delivery of information and content via any mobile or internet
            connected device or otherwise (collectively the "Service(s)").
          </p>
          <p>
            This Privacy Policy forms part and parcel of the Terms of Use for
            the Services. Capitalized terms which have been used here but are
            undefined shall have the same meaning as attributed to them in the
            Terms of Use. The Company respects the privacy of the users of the
            Services and is committed to protect it in all respects.
          </p>

          <Section title="1. Information Received, Collected and Stored by the Company">
            <p>
              We collect and process some or all of the following type of
              information in the course of you using our Services. The type of
              information we collect will depend on the circumstances and the
              Service you are using. Generally speaking, the information about
              the user as collected by the Company is: (a) data supplied by
              users and (b) data automatically tracked while navigation (c)
              data collected from any other source (collectively referred to
              as "Information").
            </p>

            <SubHeading>(a) Information Supplied by Users</SubHeading>
            <p>
              <strong>(i) Registration Data:</strong> This Information
              includes, but is not limited to, basic contact information
              provided by you on our Website, which may include your name,
              mobile number, address, e-mail address, date of birth,
              demographical information, gender, interests, preferences, place
              of work, position, country. For example, the Company may collect
              personal Information when you register on the Website, to
              subscribe to our Services or for requesting further information.
              It can also include information that we have not requested but
              which you have volunteered, such as information provided during
              interactions via comments or other submissions you have made to
              our online Services, such as online forums, in response to a
              survey, while requesting certain Services or products, or to
              enter a sweepstakes, contest, or other promotion.
            </p>
            <p>
              When you register using your other accounts like on Facebook,
              Twitter, Gmail etc. we shall retrieve Information from such
              account to continue to interact with you and to continue
              providing the Services.
            </p>
            <p>
              The Company may use your Information to provide you with
              information, special offers, and promotions via various means
              including e-mail. You may instruct Company at any time not to
              use your personal Information covered by this Privacy Policy to
              provide you with special offers and promotions.
            </p>
            <p>
              In case you choose to decline to submit personal Information on
              the Website, the Company may not be able to provide certain
              sites / content / apps / services / features to you. We will
              make reasonable efforts to notify you of the same at the time of
              opening your account. In any case, we will not be liable and/or
              responsible for the denial of certain services to you for lack
              of you providing the necessary personal Information.
            </p>
            <p>
              <strong>(ii) Subscription or Paid Service Data:</strong> You may
              choose to purchase any subscription or paid Service using a
              credit card, e-wallet or any other electronic payment system.
              When you chose any subscription or paid Service, we or our
              payment system provider may collect your purchase, address or
              billing information, including your credit card number and
              expiration date, etc. ("Payment Information"). However, when you
              order using an in-app purchase option, same are handled by such
              platform providers. Typically, the Payment information is
              provided directly by users, via the Website, into the
              PCI/DSS-compliant payment processing service to which the
              Company subscribes, and the Company does not, itself, process or
              store the Payment Information, except as stated herein.
            </p>
            <p>
              The subscriptions or paid Services may be on auto renewal mode
              unless cancelled. If at any point you do not wish to auto-renew
              your subscription, you may cancel your subscription before the
              end of the subscription term.
            </p>
            <p>
              This Payment Information is used to provide you your requested
              Services, to manage your account, to communicate with you, and
              enforce any terms of service or agreement related to the
              Website. We use any Payment Information we acquire from you only
              to fulfill your order.
            </p>
            <p>
              <strong>(iii) Information about other Individuals:</strong> In
              some circumstances you might provide us with the Information
              about other individuals. You must ensure that you (1) have their
              permission to provide their Information to us; and (2) you have
              made them aware of the terms of this Privacy Policy. By
              submitting the Information about others, you represent and
              warrant that you are authorized to do so and that you have
              received authorization from the person about whom you are
              providing the Information and that person has explicitly
              consented to have all Information used, processed, disclosed,
              and transferred in accordance with this Privacy Policy.
            </p>

            <SubHeading>
              (b) Information automatically tracked while navigation
            </SubHeading>
            <p>
              When you use our Services, we automatically record Information
              about your usage of those Services, your interaction with our
              emails as well as information about the device you are using and
              your internet connection. We do this in the following ways:
            </p>
            <p>
              <strong>(i) Use of Cookies and other Electronic Tools:</strong>{" "}
              The Company and the parties with whom we work (e.g., business
              partners, advertisers and advertising servers) may place, view,
              and/or use "cookies", web server logs, web beacons, or mapping
              pixel/pixel tag or other electronic tools to collect statistical
              and other Information about your use of the Website and other
              websites. This Information may include information about the IP
              address of your computer, browser type, language, operating
              system, your mobile device, geo-location data, the state or
              country from which you accessed the Company's Website, the web
              pages visited, the date and the time of a visit, the websites
              you visited immediately before and after visiting the Website,
              the number of links you click within the Website, the functions
              you use on the Website, the databases you view and the searches
              you request on the Website, the data you save on or download
              from the Website and the number of times you view an
              advertisement. For more information, please see our Cookies
              Policy, which forms part of this Privacy Policy and the Terms
              and Conditions of the Website.
            </p>
            <p>
              The Company and the parties with whom we work may use the
              information collected for various reasons, either on behalf of
              Company or for the other parties' own purposes, including
              research, analysis, to better serve visitors to the Website
              (such as by providing customized content, or presenting online
              advertising on the Website or other websites tailored to your
              interests as described further below), to compile aggregate and
              anonymous information about usage of the Website and other
              websites, other statistics, etc. However, if you have deleted
              and disabled cookies, these uses will not be possible to the
              extent they are based on cookie information.
            </p>
            <p>
              <strong>(ii) Log File Information:</strong> We automatically
              collect limited information about your computer's connection to
              the Internet, mobile number, etc., when you visit the Website /
              Service. We automatically receive and log information from your
              browser, including your computer's name, your operating system,
              browser type and version, IP address, CPU speed, and connection
              speed. We may also collect log information from your device,
              including your location, IP address, your device's name,
              device's serial number or unique identification number (e.g.
              UDiD on your iOS device). If you access the Services from a
              mobile or other device, we may collect a unique device
              identifier assigned to that device, geo-location data, or other
              transactional information for that device.
            </p>
            <p>
              <strong>(iii) Clear GIFs:</strong> Besides web beacons, we may
              also use clear GIFs in HTML-based emails sent to our users to
              track which emails are opened by recipients. We use this
              information to inter-alia to measure traffic within the Website
              / Service to improve the Website / Service quality,
              functionality and interactivity and let advertisers know the
              geographic locations from where our visitors come.
            </p>

            <SubHeading>
              (c) Information collected from any other source
            </SubHeading>
            <p>
              We may receive Information about you from other sources, add it
              to our account information and treat it in accordance with this
              Privacy Policy. If you provide Information to the platform
              provider or other partner, your account information and order
              information may be passed on to us. We may obtain updated
              contact information from third parties in order to correct our
              records and fulfill the Services or to communicate with you and
              you expressly consent to this.
            </p>
            <p>
              <strong>
                (i) Information from other Sources: Demographic & Purchase
                Information.
              </strong>{" "}
              We may reference other sources of demographic and other
              information in order to provide you with more targeted
              communications and promotions. We use analytical tools to track
              the user behavior on our Website. These tools have been enabled
              to support display advertising towards helping us gain
              understanding of our users' demographics and interests. The
              reports are anonymous and cannot be associated with any
              individual personally identifiable Information that you may have
              shared with us.
            </p>
            <p>
              <strong>(ii) Advertisements & Purchase Information.</strong> The
              Company or third-party advertisers or their advertising servers
              may also place or recognize unique cookies on your computer or
              use other electronic tools in order to help display
              advertisements that you see on the Website or on other websites.
              Information about your visits to, and activity on, the Website
              and other websites, an IP address, the number of times you have
              viewed an advertisement, and other such usage information is
              used, alone or in combination with other information, to display
              on your device screen advertisements that may be of particular
              interest to you. The use and collection of your Information by
              these third-party service providers, and third-party advertisers
              and their advertising servers is not covered by this Privacy
              Policy.
            </p>
          </Section>

          <Section title="2. Information Use by the Company">
            <p>
              We use Information held about you for our legitimate business
              interests for the following purposes:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                <strong>(i)</strong> To provide you Services including
                associated functionalities whether by us or by our designated
                representatives and/or business partners to you or to parties
                designated by you and any and all matters ancillary thereto
                including to carry out obligations from any contracts entered
                into between us. We rely on performance of our contract with
                you so as the legal basis for such processing;
              </li>
              <li>
                <strong>(ii)</strong> To verify and process payment when you
                subscribe to, purchase and/or obtain Services from any of our
                Website. We rely on performance of our contract with you so as
                the legal basis for such processing;
              </li>
              <li>
                <strong>(iii)</strong> For verification and record of your
                personal particulars, to authenticate you so that we know it
                is you and not someone else which includes comparing it with
                Information from other sources and using the Information to
                communicate with you;
              </li>
              <li>
                <strong>(iv)</strong> To conduct market research and
                statistical analysis of the users of the Website including the
                number of users, the frequency of use, profile of users and
                using such analysis for our business plans, the enhancement of
                our products and services, targeted advertisements;
              </li>
              <li>
                <strong>(v)</strong> To send you Information, promotions and
                updates including marketing and advertising materials in
                relation to our Services and those of third party
                organizations selected by us;
              </li>
              <li>
                <strong>(vi)</strong> To prevent fraud or other potentially
                illegal activities (including copyright infringement) and to
                block disruptive users and protect the safety of users of our
                Services;
              </li>
              <li>
                <strong>(vii)</strong> To enforce our terms of Service. The
                legal basis for this processing being the protection and
                assertion of our legal rights and the legal rights of others.
              </li>
            </ul>
            <p>
              In any case, if you would prefer that we do not use your
              Information to market or promote our products and Services to
              you, please either (i) tick the relevant box on the form through
              which we collect your Information; (ii) unsubscribe from our
              electronic communications using the method indicated in the
              relevant communication; or (iii) contact our Grievance Officer
              at the details below.
            </p>
          </Section>

          <Section title="3. Sensitive Personal Information">
            <p>
              Unless specifically requested, we ask that you not send us, and
              you shall not disclose, on or through the Services or otherwise
              to us, any sensitive personal information (e.g., information
              related to racial or ethnic origin, political opinions,
              religion, ideological or other beliefs, health, biometrics or
              genetic characteristics, national identification numbers, social
              security numbers, criminal background, trade union membership,
              or administrative or criminal proceedings and sanctions).
            </p>
          </Section>

          <Section title="4. Disclosure of Personal Information and Other Information">
            <SubHeading>
              (a) Information Shared with Group Companies and Affiliates
            </SubHeading>
            <p>
              The Company may share Information with its employees, agents,
              officers, group companies, the employees, agents and officers of
              such group companies and our affiliates (including affiliated
              websites under common ownership or control) for the purpose of
              processing Information on its behalf.
            </p>

            <SubHeading>
              (b) Information shared with Third Parties and Sponsors
            </SubHeading>
            <p>
              <strong>(i)</strong> The Company may share with other third
              parties Information about our Website users, such as your use of
              the Website or other websites, but only on an anonymous and
              aggregate basis to help us develop content, services, and
              advertising that we hope you will find of interest. The Company
              may also share your Information with a sponsor or other third
              party ("Third-Party Provider") to perform Site-related services,
              including database management, maintenance services, analytics,
              marketing, data processing, and email and text message
              distribution. These third parties have access to your
              Information only to perform these tasks only on our behalf.
            </p>
            <p>
              <strong>(ii)</strong> The Company may share Information to
              support sponsors. If you participate in certain features of the
              Website (e.g., sharing news stories of interest), please note
              that any Information you or others voluntarily disclose through
              use of these features, becomes available to the public and/or
              other users whom you have designated.
            </p>

            <SubHeading>
              (c) Information shared via third party social buttons, widgets
              and other embedded content
            </SubHeading>
            <p>
              Some of our online services carry embedded content controlled by
              third parties for services such as social sharing, recommended
              stories, commenting/reviewing, and displaying video or images.
              When you interact with these services they may collect
              information from and about you and your interaction with their
              content. This activity will be subject to the Privacy Policy of
              and your settings for your chosen network. Please be aware that
              they may track your activity, through the use of cookies or
              similar technology, without you needing to interact with them.
            </p>
            <p>
              Further, we use third-party advertising companies to serve ads
              when you visit or use the Website or Services. These companies
              may use Information (not including your name, address, email
              address or telephone number) about your visits or use to
              particular website, mobile application or services, in order to
              provide advertisements about goods and services of interest to
              you.
            </p>

            <SubHeading>(d) Information shared with Other Parties</SubHeading>
            <p>
              The Company may also disclose your personal and other
              Information to unaffiliated third parties if we believe in good
              faith that such disclosure is necessary: (i) to comply with the
              law or in response to a subpoena, court order, search warrants,
              judicial proceedings, other legal process, or other law
              enforcement measures; (ii) to protect the interests, rights,
              safety, or property of the Company or others; (iii) to enforce
              any terms of service on the Website; (iv) to investigate,
              prevent, or take action regarding illegal activities, suspected
              fraud; (v) to provide you and other users of the Website with
              the Services or products requested by you, including billing and
              collection; (vi) to provide you with special offers or
              promotions from the Company that may be of interest to you; or
              (vii) to operate the Company's systems properly.
            </p>

            <SubHeading>(e) Social Sharing Functionality</SubHeading>
            <p>
              If you log in with or connect a social media service account
              with Services, we may share your user name, picture, and likes,
              as well as your activities and comments with other Services
              users and with your friends associated with your social media
              service. We may also share the same Information with the social
              media service provider. By logging in with or connecting your
              Services account with a social media service, you are
              authorizing us to share Information we collect from and about
              you with the social media service provider. If you do not want
              your personal Information shared in this way, please do not
              connect your social media service account with your Services
              account and do not participate in social sharing on Services.
            </p>

            <SubHeading>
              (f) Sale or Transfer of all or part of Business of Company
            </SubHeading>
            <p>
              If the Company sells all or part of its business or makes a sale
              or transfer of its assets or is otherwise involved in a merger
              or transfer of all or a material part of its business, the
              Company may transfer your Information to the party or parties
              involved in the transaction as part of that transaction.
            </p>

            <SubHeading>(g) Other Purposes</SubHeading>
            <p>
              In addition to the scenarios identified above, we may share
              Information about you for any other purposes disclosed to you at
              the time we collect your Information or pursuant to your
              consent.
            </p>

            <SubHeading>(h) Some General Exceptions to Disclosures</SubHeading>
            <p>
              <strong>a)</strong> The Website Service may include links to
              other websites or applications. Such websites or applications
              are governed by their respective privacy policies, which are
              beyond our control. Once you leave our servers, use of any
              information you provide is governed by the privacy policy of the
              operator of the website / app / service you are visiting. The
              collection, further use, and/or disclosure of your Information
              by Third-Party Providers or by other third parties is not the
              responsibility of the Company.
            </p>
            <p>
              <strong>b)</strong> Any personally identifiable Information
              provided by you will not be considered as sensitive if it is
              freely available and/or accessible in the public domain like any
              comments, messages, blogs, scribbles available on social
              platforms like Facebook, Twitter etc.
            </p>
            <p>
              <strong>c)</strong> Anything posted/uploaded/conveyed/communicated
              by users in the websites/apps/services becomes published content
              and is not considered personally identifiable information
              subject to this Privacy Policy.
            </p>
          </Section>

          <Section title="5. Security of Personal Information">
            <p>
              Any personal Information you provide to Company is kept on
              secure servers with limited access. The Company uses reasonable
              administrative, technical, personnel, and physical measures (a)
              to safeguard personal Information against loss, theft,
              unauthorized use or access, disclosure, or modification; and (b)
              to ensure the integrity of the personal Information.
            </p>
            <p>
              We limit access to your personal Information to those who have a
              genuine business need to do so. We also endeavor that any
              recipient of such Information agree to process such Information
              based on our instructions and in compliance with this Privacy
              Policy and any other appropriate confidentiality and security
              measures.
            </p>
            <p>
              We also have procedures in place to deal with any suspected data
              security breach. We will notify you and any applicable regulator
              of a suspected data security breach where we are legally
              required to do so.
            </p>
            <p>
              However, as effective as our security measures are, no security
              system is impenetrable. We cannot guarantee the security of our
              database, nor can we guarantee that Information you supply will
              not be intercepted while being transmitted to us over the
              Internet; any transmission is at your own risk. And, of course,
              any Information you include in a posting to the discussion areas
              is available to anyone with Internet access.
            </p>
            <p>
              Remember that even after you cancel your account, copies of some
              Information from your account may remain viewable in some
              circumstances where, for example, you have shared information
              with social media or other services and such Information is
              outside the Company's control. Further, if you have reason to
              believe that your interaction with us is no longer secure,
              please immediately notify us.
            </p>
          </Section>

          <Section title="6. Transfer of Personal Information to Other Countries">
            <p>
              Some of the uses and disclosures mentioned in this Privacy
              Policy may involve the transfer and processing of your personal
              Information to and in various countries around the world that
              may have different levels of privacy protection than your
              country. By submitting your personal Information, you consent to
              such transfers and processing, including to and in the United
              States. In certain circumstances, courts, law enforcement
              agencies, regulatory agencies or security authorities in those
              other countries will be entitled to access your information.
            </p>
          </Section>

          <Section title="7. Rights Available to You">
            <p>
              You have a number of important rights free of charge. In
              summary, those include rights to:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                <strong>a)</strong> Access and update your Information  we
                will endeavor to update your Information within 14 working
                days of any new or updated Information being provided to us;
              </li>
              <li>
                <strong>b)</strong> Require us to correct any mistakes in your
                Information  any inaccurate or deficient Information shall
                be corrected or amended as feasible;
              </li>
              <li>
                <strong>c)</strong> Require the erasure of your Information in
                certain situations;
              </li>
              <li>
                <strong>d)</strong> Require us to restrict processing or
                object at any time to processing of personal Information in
                certain situations;
              </li>
              <li>
                <strong>e)</strong> Receive the personal Information
                concerning you which you have provided to us, in a structured,
                commonly used and machine-readable format;
              </li>
              <li>
                <strong>f)</strong> Object to decisions being taken by
                automated means which produce legal effects concerning you or
                similarly significantly affect you;
              </li>
              <li>
                <strong>g)</strong> Object in certain other situations to our
                continued processing of your personal Information;
              </li>
              <li>
                <strong>h)</strong> Otherwise restrict our processing of your
                personal Information in certain circumstances.
              </li>
            </ul>
            <p>
              We ask individual users to identify themselves and the
              Information requested to be accessed, corrected or removed
              before processing such requests. We may need to verify your
              identity before fulfilling your request. We will try to comply
              with your request as soon as reasonably practicable.
            </p>
          </Section>

          <Section title="8. Retention">
            <p>
              We will retain Information for the period necessary to fulfill
              the purposes outlined in this Privacy Policy unless a longer
              retention period is required or permitted by law. The criteria
              used to determine our retention periods include:
            </p>
            <ul className="list-disc pl-6 space-y-1">
              <li>
                The length of time we have an ongoing relationship with you
                and provide the Services to you;
              </li>
              <li>
                Whether there is a legal obligation to which we are subject;
              </li>
              <li>
                Whether retention is advisable considering our legal position
                (such as for statutes of limitations, litigation or regulatory
                investigations).
              </li>
            </ul>
          </Section>

          <Section title="9. Children Using Our Services">
            <p>
              Except where otherwise indicated, we do not knowingly collect or
              store any personal Information from children under the age of
              13. If you are aged 13 or under, we request that you do not
              provide us with Information relating to you or to others. Please
              seek the guidance of your parent or guardian before using our
              Services.
            </p>
            <p>
              If you are the parent or guardian of a child who is aged under
              16 and you become aware that your child has provided us with
              information without your consent, please contact us as given
              below. We will delete such information from our records within a
              reasonable time. Depending on the service, we may also seek to
              obtain the consent of your parent or guardian if you are under
              the age of 18.
            </p>
          </Section>

          <Section title="10. Modifications to this Privacy Policy">
            <p>
              The Company may alter this Privacy Policy to incorporate
              necessary changes in technology, applicable law or any other
              variant from time to time by posting revisions on this web page.
              Such changes will be effective upon posting. Your use of the app
              or Services after such notice will be deemed acceptance of such
              changes. In any case, you are advised to review this Privacy
              Policy periodically to ensure that you are aware of the latest
              version.
            </p>
          </Section>

          <Section title="11. Questions / Grievance Redressal">
            <p>
              All questions, comments and requests regarding this Privacy
              Policy should be addressed to the designated Grievance Officer.
              Any complaints or concerns with regards to the processing of
              information provided by you or breach of these terms shall be
              immediately informed to the designated Grievance Officer in
              writing by email.
            </p>
            <p>
              We request you to please provide the following information in
              your complaint:
            </p>
            <ul className="list-disc pl-6 space-y-1">
              <li>
                <strong>a)</strong> Your address, telephone number and e-mail
                address;
              </li>
              <li>
                <strong>b)</strong> A statement, under penalty of perjury,
                that the information in the notice is accurate.
              </li>
            </ul>
            <p>
              The company shall not be responsible for any communication, if
              addressed, to any non-designated person in this regard.
            </p>

            <div className="mt-4 p-4 bg-cream rounded-xl border border-gold/30 space-y-1">
              <p className="text-sm">
                <strong className="text-maroon">Email:</strong>{" "}
                <a
                  href="mailto:smsgold.vs@gmail.com"
                  className="text-gold-dark hover:underline"
                >
                  smsgold.vs@gmail.com
                </a>
              </p>
              <p className="text-sm">
                <strong className="text-maroon">Mobile:</strong>{" "}
                <a
                  href="tel:+919898313040"
                  className="text-gold-dark hover:underline"
                >
                  +91 98983 13040
                </a>
              </p>
              <p className="text-sm">
                <strong className="text-maroon">Enquiry:</strong>{" "}
                <a
                  href="tel:+919798993336"
                  className="text-gold-dark hover:underline"
                >
                  +91 97989 93336
                </a>
              </p>
              <p className="text-sm">
                <strong className="text-maroon">Address:</strong> Shivkumar
                Jewellers, 5/4/56, 57, 58 Swaminarayan Mandir No Kancho, Lal
                Darwaja, Visnagar, Gujarat  384315
              </p>
              <p className="text-sm">
                <strong className="text-maroon">Website:</strong>{" "}
                <a
                  href="https://shivkumarjewellers.com"
                  className="text-gold-dark hover:underline"
                >
                  shivkumarjewellers.com
                </a>
              </p>
            </div>
          </Section>

          <Section title="Cookies Policy">
            <p>
              Like most websites, the Company's website (hereinafter
              "Website") uses cookies to distinguish you from other users.
              This Policy explains how cookies are used on the Website and,
              below, how you can control the cookies that may be used on this
              Website (not all of them are used on every site).
            </p>

            <SubHeading>1. What is a Cookie?</SubHeading>
            <p>
              A cookie is a piece of software code that an internet website
              sends to your browser when you access information at that site.
              A cookie is stored as a simple text file on your computer or
              mobile device by a website's server and only that server will be
              able to retrieve or read the contents of that cookie. Cookies
              let you navigate between pages efficiently as they store your
              preferences.
            </p>
            <p>
              Generally speaking, cookies do not contain personal information
              from which you can be identified, unless you have furnished such
              information to the Website. This Website uses cookies to track
              usage and help improve features and Services. This information
              helps us monitor traffic on our Website so that we can manage
              the Website's capacity and efficiency.
            </p>

            <SubHeading>2. About this Cookie Policy</SubHeading>
            <p>
              This Cookie Policy forms part of and is incorporated into our
              Website Terms and Conditions. By accessing the Website, you
              agree that this Cookie Policy will apply whenever you access the
              Website on any device. Any changes to this Policy will be posted
              here.
            </p>

            <SubHeading>3. How we use Cookies</SubHeading>
            <p>
              We collect information on our users through registration and the
              use of the Website, through cookies, where you choose to
              disclose data in postings, and when you enter sales promotions
              and competitions. We use cookies to:
            </p>
            <ul className="list-disc pl-6 space-y-1">
              <li>
                <strong>(i) Gather statistics:</strong> We track how many
                "unique users" we have and how often they visit our Website;
              </li>
              <li>
                <strong>(ii) Flash cookies</strong> may be used to store user
                preferences for media player functionality.
              </li>
            </ul>
            <p>
              By using the sites you are agreeing to the use of cookies as
              described.
            </p>

            <SubHeading>4. Types of cookie that may be used</SubHeading>
            <p>
              <strong>A. First Party Cookies</strong>  our own cookies
              controlled by us and used to provide information about usage of
              our site (Personalisation cookies, Analytics cookies and Site
              management cookies).
            </p>
            <p>
              <strong>B. Third Party Cookies</strong>  cookies found in
              other companies' internet tools which we are using to enhance
              our Website, for example Facebook, Twitter, have their own
              cookies, pixel tags, etc. which are controlled by them. We have
              no control on such cookies.
            </p>

            <SubHeading>5. Turning off Cookies</SubHeading>
            <p>
              Most browsers allow you to turn off cookies (including essential
              cookies). However, switching off cookies may restrict your use
              of the Website and/or affect the way in which the Website
              operates. All modern browsers allow you to change your cookie
              settings. These settings will typically be found in the
              "options" or "preferences" menu of your browser.
            </p>
          </Section>
        </article>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="font-serif text-xl md:text-2xl text-maroon font-bold mb-3 pb-2 border-b-2 border-gold/30">
        {title}
      </h2>
      <div className="space-y-3 text-[15px]">{children}</div>
    </div>
  );
}

function SubHeading({ children }) {
  return (
    <h3 className="font-semibold text-maroon-dark mt-4 mb-1">{children}</h3>
  );
}
